<div id="experiencias" class="experiencias" *ngIf="experienciasFiltradas.length > 0">
  <div class="experiencias__header" *ngIf="!paginaMomentosEspeciais">
    <div class="experiencias__titulo">
      <img
        src="assets/images/logos/momentos_especiais.svg"
        alt="Momentos Especiais"
      />
    </div>
    <div class="div__subtitle_momentos">
      <p class="experiencias__subtitulo">
        Resgate os produtos Cacau Show com os seus cacaus:
      </p>
    </div>
  </div>

  <div class="experiencias__header" [ngClass]="{'ajuste--momentos': paginaMomentosEspeciais}" *ngIf="paginaMomentosEspeciais">
    <div class="div__subtitle_momentos">
      <p class="header__titulo__produtos">
        Exclusivos Cacau Show
      </p>
    </div>
  </div>

  <div class="experiencias__container">
    <div class="container__restantes" *ngIf="exibirProgressoProximoNivel()">
      <div class="restantes__progresso">
        <div class="progresso__bg"></div>
        <div
          class="progresso__valor"
          [ngStyle]="calcularPorcentagemProximoNivel()"
        ></div>
      </div>

      <p class="pontos__restantes">
        Faltam
        <span class="lovers-font--color lovers-font--bold">
          {{ pontuacaoRestanteProximoNivel }} pontos
        </span>
        para desbloquear esse nível!
      </p>
    </div>

    <div
      [ngClass]="{
        'experiencias--sem-progresso': !exibirProgressoProximoNivel(),
        'pag--momentos': paginaMomentosEspeciais
      }"
      class="container__experiencias"
      *ngIf="!carregandoExperiencias && this.experiencias.length > 0"
      #exp
      (mousedown)="startDragging($event, false, exp)"
      (mouseup)="stopDragging($event, false)"
      (mouseleave)="stopDragging($event, false)"
      (mousemove)="moveEvent($event, exp)"
    >
      <app-card-experiencia-produtos
        *ngFor="let experiencia of experienciasFiltradas"
        [id]="experiencia.id"
        [idGrupo]="experiencia.idGrupo"
        [preco]="experiencia.precoEmCacaus"
        [imagemSrc]="experiencia.imagemSrc"
        [titulo]="experiencia.nome"
        [descricao]="experiencia.descricao"
        [validade]="experiencia.dataFim"
        [nivel]="nivelSelecionadoDescricao"
        [idNivelExperiencia]="experiencia.idNivel"
        [idNivelMembro]="idMembro"
        [quantidadeDisponivel]="experiencia.quantidadeDisponivel"
        [tag]="experiencia.tag"
        [destaque]="experiencia.destaque"
        [niveis]="experiencia.experienciaNiveis"
        [nomeIdentificador]="experiencia.nomeIdentificador"
        [estaEmMomentos]="paginaMomentosEspeciais"
      ></app-card-experiencia-produtos>
    </div>

    <div
      class="container__experiencias experiencias__loader loader--desktop"
      *ngIf="carregandoExperiencias"
    >
      <div
        class="experiencias__experiencia"
        *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]"
      >
        <ngx-skeleton-loader
          [theme]="{
            'border-radius': '24px',
            width: '213px',
            height: '338px',
            display: 'block'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>

    <div
      class="container__experiencias experiencias__loader loader--mobile"
      *ngIf="carregandoExperiencias"
    >
      <div class="experiencias__experiencia" *ngFor="let i of [1, 2, 3]">
        <ngx-skeleton-loader
          [theme]="{
            'border-radius': '24px',
            width: '164px',
            height: '244px',
            display: 'flex'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>
